/**
*
* AlertCookies
*
*/

import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { ActionButton } from '@landing_academy/shared';

import media from '../../style/mediainjector';
import { cookieSet } from '../../utils/cookies'
import googleAnalyticsWrapper from '../../utils/googleAnalyticsWrapper'


export const AlertCookiesWrap = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 2rem 2rem;
  z-index: 1;
  ${({ hide }) => hide && css`
    display: none;
  `}
`;

export const CookiesBanner = styled.div`
  color: inherit;
  max-width: 860px;
  margin: 0 auto;
  background-color: rgba(255,255,255,.95);
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,.55);
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  p {
    padding: 20px 20px 12px 20px;
    margin: 0;
    &:last-child {
      padding: 10px 20px 20px;
      text-align: right;
    }
  }
`;

const AlertCookieActions = styled.p`
  button {
    margin-top: 8px;

    &:first-child {
      margin-right: 8px;
    }
    ${media.lt667`
      width:100%;
    `}
  }
`;


// FIXME: dare un nome più descrittivo al componente, visto che non è solo il banner
// dei cookie ma registra pure le analytics
const AlertCookies = ({
  locationPathname,
  setGDPRChoicesFunction,
  pageTitle,
  userSettings: { gdprPreferencesEnabled, gdprAnalyticsEnabled }
}) => {
  // trick-porcheria per aggirare l'hydration di gatsby
  // e forzare l'aggiornamento del contenuto del wrapper cookie sul front-end
  // https://github.com/gatsbyjs/gatsby/issues/14601#issuecomment-499922794
  const [isClient, setClient] = useState(false)

  useEffect(() => {
    if (gdprAnalyticsEnabled) {
      googleAnalyticsWrapper('send', {
        hitType: 'pageview',
        path: locationPathname,
        title: pageTitle,
      })
    }
  }, [gdprAnalyticsEnabled, locationPathname]);

  useEffect(() => {
    setClient(true)
  }, [])

  return (
    <AlertCookiesWrap
      hide={!isClient || !process.env.GATSBY_UA_ANALYTICS || gdprPreferencesEnabled}
      key={isClient ? `client` : `server`}
    >
      <CookiesBanner>
        <p>Al fine di offrire il miglior servizio possibile questo sito utilizza cookies tecnici e di terze parti per funzionalità quali l&apos;accesso tramite social network e/o la visualizzazione di media. Se non acconsenti all&apos;utilizzo dei cookie di terze parti, alcune di queste funzionalità potrebbero essere non disponibili. Chiudendo questo banner o proseguendo con la navigazione acconsentirai al loro impiego. Per saperne di pi&ugrave; o negare il consenso a tutti o ad alcuni cookie puoi consultare <a href="https://maieuticallabs.it/privacy" rel="noopener noreferrer" target="_blank"><span>l&apos;informativa sulla privacy</span></a>.</p>
        <AlertCookieActions>
          <ActionButton
            padding="12px 24px"
            shadow
            onClick={() => {
              cookieSet({ cookieKey: 'gdpr_preferences_set', payload: 'true' });
              cookieSet({ cookieKey: 'gdpr_analytics_on', payload: 'false' });
              setGDPRChoicesFunction({ gdprPreferencesEnabled: true, gdprAnalyticsEnabled: false })
            }}
          >Accetta solo essenziali
          </ActionButton>
          <ActionButton
            padding="12px 24px"
            shadow
            onClick={() => {
              cookieSet({ cookieKey: 'gdpr_preferences_set', payload: 'true' });
              cookieSet({ cookieKey: 'gdpr_analytics_on', payload: 'true' });
              setGDPRChoicesFunction({ gdprPreferencesEnabled: true, gdprAnalyticsEnabled: true })
            }}
          >Accetta tutti
          </ActionButton>
        </AlertCookieActions>
      </CookiesBanner>
    </AlertCookiesWrap>
  );
}


export default AlertCookies;
